import React from 'react';

import classNames from './EABDSeeTheJourneyButton.module.scss';

export interface SeeTheJourneyButtonProps
  extends Readonly<{
    text: string;
    onPress: () => void;
  }> {}

export const SeeTheJourneyButton = React.memo<SeeTheJourneyButtonProps>((props) => {
  const { text, onPress } = props;

  return (
    <button onClick={onPress} type={'button'} className={classNames.button}>
      <p className={classNames.text}>{text}</p>
      <div className={classNames.circle}>
        <div className={classNames.arrow} />
      </div>
    </button>
  );
});
